import { settings } from '../../../settings/settings-util'
import watch from 'redux-watch'

export default class nextitConversationareaScrolltoinput {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        try {
            this.setupQueries(this._settings);
        } catch (e) {
            console.error("nextitConversationareaScrolltoinput error: " + e);
        }
    }

    static getDefaultSettings() {
        return settings;
    }

    setupQueries(settings) {
        const windowRoot = this._settings.Window.rootId;
        const conversationAreaClass = this._settings.classNames.conversationAreaClassName;
        const userInputClass = this._settings.classNames.userInputClassName;

        if (!settings.Scroll) 
            settings.Scroll = {};

        this._userInputQuery = settings.Scroll.userInputQuery ||
            `div.${conversationAreaClass} > div.${userInputClass}`;

        this._almeResponseQuery = settings.Scroll.almeResponseQuery ||
            `div.${conversationAreaClass} > div:not(${userInputClass})`;

        this._conversationAreaQuery = settings.Scroll.conversationAreaQuery ||
            `div.${conversationAreaClass}`;
    }

    initialize(store) {
        this._store = store;
        this.setupWatch();
        this._nIntervId = null;
    }

    scrollToLastInput(focusLastInput = false) {
        HTMLCollection.prototype.forEach = Array.prototype.forEach;
        NodeList.prototype.forEach = Array.prototype.forEach;
        let lastInputHeight = 0;
        let lastResponseHeight = 0;
        let inputMargin = 0;
        let responseMargin = 0;

        const userInputs = document.querySelectorAll(this._userInputQuery);
        if (userInputs.length > 0)
        {
            let lastUserInput = userInputs[userInputs.length - 1];
            inputMargin += parseInt(window.getComputedStyle(lastUserInput).getPropertyValue('margin-bottom'));
            inputMargin += parseInt(window.getComputedStyle(lastUserInput).getPropertyValue('margin-top'));
            lastInputHeight = 0;
            lastUserInput.children.forEach(child => { 
                if(child.className !== this._settings.classNames.userInputPersonaIconClassName){
                    lastInputHeight += child.scrollHeight;
                }
            }); 
            
            if (focusLastInput) { lastUserInput.querySelector(`.${this._settings.classNames.userInputMessageClassName}`).focus(); }
        }
        
        const almeResponses = document.querySelectorAll(this._almeResponseQuery);
        if (almeResponses.length > 0) {
            let lastAlmeResponse = almeResponses[almeResponses.length - 1];
            lastResponseHeight = 0;
            responseMargin += parseInt(window.getComputedStyle(lastAlmeResponse).getPropertyValue('margin-top'));
            responseMargin += parseInt(window.getComputedStyle(lastAlmeResponse).getPropertyValue('margin-bottom'));
            lastAlmeResponse.children.forEach(child => 
                { 
                    if(child.className !== this._settings.classNames.almeResponsePersonaIconClassName)
                    {
                        lastResponseHeight += child.scrollHeight; 
                    } 
                });
        }

        const conversationArea = document.querySelector(this._conversationAreaQuery);
        if (conversationArea) {
            let elementEmbedIVA = document.getElementById(this._settings.elementIds.embeddIVA);
            if (elementEmbedIVA !== null) {
                window.scroll({
                    top: conversationArea.lastElementChild.offsetTop,
                    left: 0,
                    behavior: "smooth",
                  });
            }
            else {
                let paddingBottom = parseInt(window.getComputedStyle(conversationArea).getPropertyValue('padding-bottom'));
                conversationArea.scrollTop = conversationArea.scrollHeight - (lastInputHeight + lastResponseHeight + paddingBottom + inputMargin + responseMargin);
            }
        }
    }

    setupWatch() {
        let historyWatcher = watch(this._store.getState, `${this._settings.stateLocations.History.Base}.${this._settings.stateLocations.History.Messages}`);
        this._store.subscribe(historyWatcher((newVal, oldVal, path) => {
            // Got new responses - scroll to them
            //wait for elements to be rendered
            if (newVal.length > oldVal.length) {
                if (this._nIntervId === null) this._nIntervId = setInterval(() => this.checkForElements(), 100);
            }
        }));

        let path = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.SkipToContent.Base}.${this._settings.stateLocations.Window.SkipToContent.ShouldSkipToContent}`;
        let shouldSkipToContentWatcher = watch(this._store.getState, path);
        this._store.subscribe(shouldSkipToContentWatcher((newVal, oldVal, path) =>
        {
            if (newVal === true)
            {
                let accessibility = this._settings.accessibility || {};
                let focusable = accessibility.focusable || {};

                this.scrollToLastInput(focusable.userInputResponseMessage);
            }
        }));
    }

    checkForElements() {
        let almeResponses = document.querySelectorAll(this._almeResponseQuery);
        if (almeResponses.length > 0) {
            this.scrollToLastInput();
            clearInterval(this._nIntervId);
            this._nIntervId = null;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/conversationarea-scrolltoinput/src/conversationarea-scrolltoinput.js